import React, { useEffect, useState, useMemo } from 'react';
import { Grid, Box, InputLabel, Button, Dialog, DialogContent, DialogActions, DialogContentText, Tooltip } from '@mui/material';
import moment from 'moment' // con esto manejamos las fechas bien
import { grey } from "@mui/material/colors";
import { UrlApi } from '../../../../services/apirest';
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Notify from '../../../Notify';
import { enviarsms } from '../../../../services/services';
import { logEventos } from '../../../../services/services';
import { getData } from '../../../../services/library';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import DialogObservacionesPedido from '../crearRepartos/DialogObservacionesPedido';
import DialogObservacionesInternas from '../crearRepartos/DialogObservacionesInternas';
import DialogObservacionesCC from '../crearRepartos/DialogObservacionesCC';

export default function Modalagregarpedidos(props) {
    const [pedidos, setPedidos] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [totalkilos, setTotalkilo] = useState(0);
    const [datosSeleccionados, setDatosSeleccionados] = useState(null);
    const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
    const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
    const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
    const [error, setError] = useState(null); //guardará el error que lance la api (si existe)  3
    const globalTheme = useTheme();
    const [disbtn, setDisbtn] = useState(false);
    const [openObsAdminChofer, setOpenObsAdminChofer] = useState(false);
    const [openObsInternas, setOpenObsInternas] = useState(false);
    const [openObsCC, setOpenObsCC] = useState(false);
    // Pedido cuyas observaciones se están viendo. Va separado de
    // datosSeleccionados (los pedidos tildados que se envían al confirmar).
    const [pedidoObs, setPedidoObs] = useState(null);

    const obtenerPedidos = () => {
        getData('/pedidos/sucursales/' + props.datos.id_sucursal, setPedidos)
    };

    const handleOnClickObsAdminChofer = (pedido) => {
        setPedidoObs(pedido)
        setOpenObsAdminChofer(true)
    }

    const handleOnClickObsInternas = (pedido) => {
        setPedidoObs(pedido)
        setOpenObsInternas(true)
    }

    const handleOnClickObsCC = (pedido) => {
        setPedidoObs(pedido)
        setOpenObsCC(true)
    }

    // console.log("props.datos", props.datos.nro_reparto);

    useEffect(() => {
        obtenerPedidos()
        props.actualizar()
    }, []);

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };
console.log("ROW ORIGINAL",pedidos);

    const columns = useMemo(() =>
        [
            {
                header: "Cliente",
                accessorFn: (c) =>
                    `${c.IDsisven ?? ""} - ${c.razon_social} (${c.empresa})|${c.cantidad_observaciones}|${c.observaciones_internas ?? 0}`,
                enableEditing: false,
                Cell: ({ cell, row }) => {

                    const [texto, cantidadObs, obsInternas] = cell.getValue().split("|");

                    const cantidad = parseInt(cantidadObs, 10);
                    const internas = parseInt(obsInternas, 10);

                    const mostrarIcono = cantidad > 0 || internas > 0;

                    return (
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            
                            {cantidad > 0 && (
                                <Tooltip
                                    title={"Observaciones CUENTAS CORRIENTES"}
                                >
                                    <FindInPageIcon
                                        onClick={() => {
                                            handleOnClickObsCC(row.original)
                                        }}
                                        style={{ color: "orange" }}
                                        size="small"
                                    />
                                </Tooltip>
                            )}

                            <Tooltip
                                title={"Observaciones chofer/logística"}
                            >
                                <FindInPageIcon
                                    onClick={() => {
                                        handleOnClickObsAdminChofer(row.original)
                                    }}
                                    style={{ color: "green" }}
                                    size="small"
                                />
                            </Tooltip>
                            <Tooltip
                                title={"Observaciones internas"}
                            >
                                <FindInPageIcon
                                    onClick={() => {
                                        handleOnClickObsInternas(row.original)
                                    }}
                                    style={{ color: "pink" }}
                                    size="small"
                                />
                            </Tooltip>
                            {texto}

                            {/* {mostrarIcono && (
                                <Tooltip title={cantidad ? "Observaciones pendientes por leer ESTE ES" : "Comentarios internos registrados "}>
                                    <FindInPageIcon style={{ color: cantidad ? "orange" : "green" }} size="small" />

                                </Tooltip>
                            )}
                            {texto} */}
                        </div>
                    );
                },
            },
            { header: 'Localidad', accessorKey: 'localidad_direccion', enableEditing: false, size: 70 },
            { header: 'Dir.Entrega', accessorFn: (c) => `${c.direccion_entrega} (${c.nombre_direccion})`, enableEditing: false },
            { header: 'Obs', accessorFn: (o) => o.obs_chofer ?? o.observaciones, enableEditing: false },
            { header: 'Requerido', accessorKey: 'kgacargar', size: 70, enableEditing: false },
            { header: 'Porcentaje (%)', accessorKey: 'porcentaje', size: 70, enableEditing: false },
            { header: 'Registrado', accessorFn: (reg) => moment(reg.registrado).format("DD-MM-YYYY"), type: "date", format: "YYYY-MM-DD", enableEditing: false, size: 60 },
            { header: 'Orden', accessorKey: 'orden_prioridad', type: 'numeric', size: 50 }
        ], []);

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary, //primary color for the table
                    info: {
                        main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000", //pure black table in dark mode for fun
                    },
                },
                typography: {
                    button: {
                        textTransform: "none", //customize typography styles for all buttons in table by default
                        fontSize: "1.2rem",
                    },
                },
            }), [globalTheme]);

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 10 }
    };

    useEffect(() => {
        const { datosSeleccionados, totalkilos } = Object.keys(rowSelection).reduce((result, key) => {
            if (rowSelection[key]) {
                result.datosSeleccionados.push({ id: pedidos[key].idpedido, "id_estado": 23, "nro_reparto": props.datos.nro_reparto, razon_social: pedidos[key].razon_social, nombre_direccion: pedidos[key].nombre_direccion, kgacargar: pedidos[key].kgacargar })
                result.totalkilos += pedidos[key].kgacargar;
            }
            return result;
        }, { datosSeleccionados: [], totalkilos: 0 });
        setDatosSeleccionados(datosSeleccionados);
        setTotalkilo(totalkilos);
    }, [rowSelection, totalkilos]);

    const ponernumerodereparto = async (e) => {
        e.preventDefault();
        setDisbtn(true);

        // Extraemos el ID del reparto de entrada para asegurar la recarga después
        const idParaCargar = props.datos?.nro_reparto;

        try {
            const response = await fetch(`${UrlApi}/pedidos/x/delivery1`, {
                method: "PUT",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(datosSeleccionados)
            });

            const contentType = response.headers.get("content-type");
            let json = null;

            if (contentType && contentType.includes("application/json")) {
                json = await response.json();
            }

            // --- CASO 1: LA PETICIÓN FUE EXITOSA (200-299) ---
            if (response.ok) {

                props.actualizar();
                props.recargar(true);
                if (props.tabla) props.tabla(true);


                if (idParaCargar) {
                    props.recargarPedidos(idParaCargar);
                }

                setMensaje(json?.message || "Guardado");
                setNotificacion(true);
                setOpenSnack(true);

                if (props.datos?.estado === 8 && props.datos?.telefono) {
                    const razonSocial = datosSeleccionados[0]?.razon_social?.trim() || "Cliente";
                    const mensajeSms = `Se asigno un nuevo pedido para: ${razonSocial}. \n Refresque App.`;
                    enviarsms(props.datos.telefono, mensajeSms);
                }

                logEventos("Poner nro de reparto", "Pedidos", "Repartos", localStorage.getItem("user"));
                return;
            }

            if (json && json.sqlMessage) {
                setError(json);
                alert(`SQL erróneo (${json.code})`);
            } else {
                alert("Inconvenientes con la API. No se pudo guardar.");
            }

        } catch (error) {
            console.error("Error en la petición:", error);

            // Manejo especial por si el servidor guardó pero devolvió algo que rompió el fetch
            if (idParaCargar) {
                props.actualizar();
                props.recargarPedidos(idParaCargar);
            }
            alert("Error de conexión o de respuesta: " + error.message);
        } finally {
            setDisbtn(false);
        }
    };

    return (
        <div>
            <Dialog open={props.open} onClose={() => { props.open(false) }} fullScreen={true}>
                {pedidos && pedidos.length > 0 ?
                    <DialogContent>
                        <Grid
                            p={2}
                            container
                            backgroundColor={grey[100]}
                            border={1}
                            borderColor={grey[300]}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item xs={2}>
                                    <InputLabel focused>Capacidad </InputLabel>
                                    <InputLabel >{props.datos.capacidad}</InputLabel>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel focused>Kg cargados </InputLabel>
                                    <InputLabel >{props.datos.kgxreparto}</InputLabel>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel focused> Disponible </InputLabel>
                                    <InputLabel >{(props.datos.capacidad - props.datos.kgxreparto) - totalkilos}</InputLabel>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel focused> Fecha de salida </InputLabel>

                                    <InputLabel >{moment(props.datos.fecha_salida_reparto).format("DD-MM-YYYY")}</InputLabel>

                                </Grid>
                            </Grid>

                        </Grid>

                        <ThemeProvider theme={tableTheme}>
                            <Box mt={2} mb={3} boxShadow={3}>
                                <MaterialReactTable
                                    positionActionsColumn="last"
                                    enableColumnResizing
                                    columns={columns}
                                    enableColumnFilters={false}
                                    data={pedidos}
                                    initialState={initialState}
                                    state={{ rowSelection }}
                                    muiTableHeadCellProps={tableHeadCellProps}
                                    enableToolbarInternalActions={true}
                                    enableRowSelection
                                    onRowSelectionChange={setRowSelection}
                                    muiTableBodyCellProps={({ row }) => ({
                                        align: "center",
                                        sx: {
                                            backgroundColor: "#ffffff",
                                            color: "black",
                                            borderColor: "black",
                                        },
                                    })}
                                    enableExpandAll={false}
                                    muiSearchTextFieldProps={muiSearchTextFieldProps}
                                    enableDensityToggle={false}
                                    layoutMode="semantic"
                                    displayColumnDefOptions={{
                                        "mrt-row-select": {
                                            size: 1,
                                        },
                                    }}
                                    localization={MRT_Localization_ES}
                                    enableColumnDragging={false}
                                    enableHiding={false}
                                    enablePagination={true}
                                    positionExpandColumn='first'
                                    //
                                    // enableBottomToolbar={false}
                                    enableStickyHeader
                                />
                            </Box>
                        </ThemeProvider>

                        <DialogActions>
                            <Grid mt={2} container direction="row" justifyContent="space-between" alignItemns="center">

                                <Button onClick={() => props.open(false)} variant="outlined" color="error" >
                                    Volver
                                </Button>

                                <Button onClick={ponernumerodereparto} variant="outlined" color="success" disabled={disbtn}>
                                    Confirmar
                                </Button>

                            </Grid>
                        </DialogActions>
                    </DialogContent>
                    :
                    <DialogContent>
                        <DialogContentText textAlign={"center"}>
                            No hay pedidos pendientes para asignar a este reparto
                        </DialogContentText>
                        <DialogActions>
                            <Grid item flex={0} container direction="column">
                                <Grid item xs={4}>
                                    <Button onClick={() => props.open(false)} variant="outlined" color="error" >
                                        Volver
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </DialogContent>
                }

                {
                    notificacion ? (
                        <Notify
                            mensaje={mensaje}
                            open={openSnack}
                            color={"#D4EFDF"}
                            severity={"success"}
                            handleClose={() => {
                                props.recargar(true)
                                props.actualizar()
                                props.open(false)
                                props.tabla(true)
                            }}
                        />
                    ) : null
                }
                {openObsAdminChofer && (
                    <DialogObservacionesPedido
                        open={openObsAdminChofer}
                        setOpen={setOpenObsAdminChofer}
                        pedido={pedidoObs}
                        handleClose={() => setOpenObsAdminChofer(false)}
                    />
                )}
                {openObsCC && (
                    <DialogObservacionesCC
                        open={openObsCC}
                        setOpen={setOpenObsCC}
                        pedido={pedidoObs}
                        handleClose={() => setOpenObsCC(false)}
                    />
                )}
                {openObsInternas && (
                    <DialogObservacionesInternas
                        open={openObsInternas}
                        setOpen={setOpenObsInternas}
                        pedido={pedidoObs}
                        handleClose={() => setOpenObsInternas(false)}
                    />
                )}
            </Dialog>
        </div>
    )

}